<template>
  <div class="text-center pa-5">
    <div
      :style="dynamicStyle"
      class="priceIconContainer d-flex flex-column justify-space-between mx-auto"
    >
      <div class="iconContainer">
        <v-icon x-large color="white">mdi-star</v-icon>
      </div>
      <div class="textContainer">
        <p class="mb-0 amount">
          <sup>$</sup>
          {{ amount }}
        </p>
        <p class="mb-0 frequency">/ {{ frequency }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    amount: {
      type: [String, Number],
      required: true,
    },
    frequency: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      required: false,
      default: 120,
    },
    height: {
      type: Number,
      required: false,
      default: 120,
    },
  },
  computed: {
    dynamicStyle() {
      return {
        height: `${this.height}px`,
        width: `${this.width}px`,
      };
    },
  },
};
</script>
<style scoped>
.priceIconContainer {
  background-color: #179ce3;
  border-radius: 50%;
  overflow: hidden;
  transition: all 0.2s ease;
}
.priceIconContainer:hover {
  background-color: #1eadf5;
}
.priceIconContainer:hover p {
  color: white;
}
p {
  color: #34495f;
  transition: all 0.2s ease;
  line-height: 1;
}
.amount {
  font-size: 33px;
}
.frequency {
  font-size: 15px;
}
.iconContainer {
  height: 50%;
  display: inline-flex;
  align-content: center;
  justify-content: center;
}
.textContainer {
  height: 50%;
}
</style>
